import { directoryClubListResponseSchema } from "../schemas/directory-club";
import { fetchApi } from "./internal";

// Public discovery directory of DVV clubs. Used by the widget page to map the
// portal club onto its directory slug for the embeddable ranking widget.
export const directory = {
	searchClubs: (params: { q: string; limit?: number }) => {
		const searchParams = new URLSearchParams({ q: params.q });
		searchParams.set("limit", String(params.limit ?? 8));
		return fetchApi(
			`/public/directory/clubs?${searchParams.toString()}`,
			directoryClubListResponseSchema,
		);
	},
};
